module.exports = __webpack_public_path__ + "img/Datastorage.svg";


//////////////////
// WEBPACK FOOTER
// ./img/Datastorage.svg
// module id = 249
// module chunks = 0